export type DropPoint = { x: number; y: number };

export type GroundDropBounds = {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
};

/**
 * Keep ordinary loose props inside the authored walkable ground band.
 * Optional floorY: drops above the floor (y < floorY) land on floorY
 * instead of the rectangle minY. Below-floor still clamps to maxY.
 */
export function projectGroundDrop(
  point: DropPoint,
  bounds: GroundDropBounds,
  floorY?: number,
): DropPoint {
  const minX = Math.min(bounds.minX, bounds.maxX);
  const maxX = Math.max(bounds.minX, bounds.maxX);
  const minY = Math.min(bounds.minY, bounds.maxY);
  const maxY = Math.max(bounds.minY, bounds.maxY);
  const x = Math.min(maxX, Math.max(minX, point.x));

  if (floorY !== undefined) {
    const y = point.y < floorY ? floorY : point.y;
    return { x, y: Math.min(maxY, y) };
  }

  return {
    x,
    y: Math.min(maxY, Math.max(minY, point.y)),
  };
}
